import {
    FEATURE_TAB_UPDATE_UNIT_REQUEST,
    FEATURE_TAB_UPDATE_UNIT_RESULT,
    FEATURE_TAB_GET_DEVICE_REQUEST,
    FEATURE_TAB_GET_DEVICE_RESULT,
    FEATURE_TAB_OPEN_MODAL,
    FEATURE_TAB_CLOSE_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    deviceId: null,
    loading: false,
    result: null,
    currentDevice: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case FEATURE_TAB_UPDATE_UNIT_REQUEST:
            return { ...state, loading: true }

        case FEATURE_TAB_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case FEATURE_TAB_GET_DEVICE_RESULT:
            return { ...state, loading: false, currentDevice: action.payload }

        case FEATURE_TAB_UPDATE_UNIT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case FEATURE_TAB_OPEN_MODAL:
            return { ...state, openModal: true, deviceId: action.payload }
        case FEATURE_TAB_CLOSE_MODAL:
            return { ...state, openModal: false, result: null }

        case CLEAR_REDUX:
            return ["", "FEATURE_TAB_UPDATE_FEATURES"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};